import { useSelector } from "react-redux";

function useHasPermission(permission, clientId = null) {
  const { authObject } = useSelector(({ authReducer }) => authReducer);

  const permissionAuthorized = (permission, clientId) => {
    let permissions = authObject?.actions;

    if (!permissions) {
      return false;
    }

    const keys = permission.split(".") || ["WILDCARD"];

    for (let i = 0; i < keys.length; i++) {
      let k = keys[i];

      if (k in permissions) {
        permissions = permissions[k];
      } else {
        return false;
      }
    }

    return permissions === true || permissions === 1;
  };

  const permissionAuthorizedForRole = (permission, roleActions) => {
    if (!roleActions) return false;
    
    let permissions = roleActions;
    const keys = permission.split(".") || ["WILDCARD"];

    for (let i = 0; i < keys.length; i++) {
      let k = keys[i];

      if (k in permissions) {
        permissions = permissions[k];
      } else {
        return false;
      }
    }

    return permissions === true || permissions === 1;
  };

  const hasAccess = (permission, clientId) => {
    if (permission === "WILDCARD") {
      return true;
    }

    if (!authObject) {
      return false;
    }

    if (authObject.isAdmin) {
      return permissionAuthorized(permission, clientId);
    }

    if (!authObject.actions) {
      return false;
    }

    if (authObject.clientRoles && authObject.clientRoles.length > 0) {
      if (!clientId) {
        const hasPermissionInAnyClient = authObject.clientRoles.some(cr => {
          if (!cr.roles || !Array.isArray(cr.roles)) return false;
          return cr.roles.some(roleId => {
            if (!authObject.roleActions || !authObject.roleActions[roleId]) return false;
            const roleActions = authObject.roleActions[roleId];
            return permissionAuthorizedForRole(permission, roleActions);
          });
        });
        return hasPermissionInAnyClient;
      }

      const clientRole = authObject.clientRoles.find(cr => {
        const clientMatches = cr.client && (
          cr.client._id === clientId || 
          cr.client._id.toString() === clientId ||
          (typeof clientId === 'string' && cr.client._id.toString() === clientId)
        );
        return clientMatches;
      });
      
      if (!clientRole) {
        return false;
      }

      if (!clientRole.roles || !Array.isArray(clientRole.roles)) {
        return false;
      }

      return clientRole.roles.some(roleId => {
        if (!authObject.roleActions || !authObject.roleActions[roleId]) {
          return false;
        }
        const roleActions = authObject.roleActions[roleId];
        return permissionAuthorizedForRole(permission, roleActions);
      });
    }

    if (authObject.roles && authObject.roles.length) {
      return permissionAuthorized(permission, clientId);
    }

    return false;
  };

  if (permission instanceof Array) {
    let permitted = true;

    for (let i = 0; i < permission.length; i++) {
      permitted = hasAccess(permission[i], clientId);
    }

    return permitted;
  } else {
    return hasAccess(permission, clientId);
  }
}

export { useHasPermission };
